// Custom fabric events fired to mark the beginning and end of grouped modifications
// onChange handler will not be called while in a group.
// Groups may be nested and the onChange handler will not be called
// until the last group is ended.
export const FABRIC_GROUP_START = 'groupedEvents:start';
export const FABRIC_GROUP_END = 'groupedEvents:end';

// Custom UYO events
export const UYO_SELECT_FIRST = 'canvas:uyo:select:first';

// Custom textbox events
export const TEXTBOX_SELECT_FIRST = 'canvas:textbox:select:first';
